import React from "react";
import {Group, Rect, Text} from "react-konva";

// Coordinate PAGINA (full-res), come le gabbie e il resto del disegno: il badge scala col
// canvas (zoom in/out) esattamente come i prezzi stampati sul volantino. Le misure sono
// tarate su una pagina da ~2350 px: a "pagina intera" (~30%) il numero resta leggibile.
const HEIGHT = 58;
const FONT = 38;
const PAD_X = 17;
const CHAR_W = 23;
const MARGIN = 9;

/**
 * Etichetta col seriale della gabbia, disegnata in alto a DESTRA del rettangolo
 * (coordinate preview). L'angolo in alto a sinistra resta libero per ManualZoneBadge.
 *
 * `taken` marca, sul canvas del riferimento, i seriali gia' portati nella variante:
 * badge in negativo con spunta, cosi' si vede a colpo d'occhio cosa e' gia' stato preso.
 * Non intercetta eventi: la selezione resta del rettangolo sottostante.
 */
// `dimmed`: gabbia esclusa dalla ricerca in corso, il badge si attenua insieme al rettangolo.
export default function ZoneSerialBadge({x, y, w, seriale, color = "#1f2937", taken = false, dimmed = false})
{
	if (seriale == null || seriale === "")
		return null;

	const text = taken ? `✓ #${seriale}` : `#${seriale}`;
	const width = PAD_X * 2 + text.length * CHAR_W;
	// Su gabbie strettissime il badge sborderebbe a sinistra: lo si ancora al bordo sinistro.
	const offsetX = Math.max(MARGIN, w - width - MARGIN);

	return (
		<Group x={x + offsetX} y={y + MARGIN} listening={false} opacity={dimmed ? 0.3 : 1}>
			<Rect
				width={width}
				height={HEIGHT}
				cornerRadius={7}
				fill={taken ? "#ffffff" : color}
				stroke={taken ? color : undefined}
				strokeWidth={taken ? 2.5 : 0}
				opacity={0.95}
				shadowColor="#000000"
				shadowBlur={5}
				shadowOpacity={0.3}
			/>
			<Text
				text={text}
				x={PAD_X}
				y={(HEIGHT - FONT) / 2}
				fontSize={FONT}
				fontStyle="bold"
				fill={taken ? color : "#ffffff"}
			/>
		</Group>
	);
}
